import { Component, OnInit, Signal, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from '@core/services/infrastructure/localstorage.service';
import { AuthService } from '@core/services/entities/auth.service';
import { RouterModule } from '@angular/router';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { STORAGE_USER_PERSON } from '@shared/utils/constants/storage.constant';
import { OrganizationCompanyModel } from '@domain/organization-company/models/organization-company.model';
import { UserPersonModel } from '@domain/user-person/models/user-person.model';
import { TopbarService } from '../../../../core/services/presenters/topbar.service';
import { Observable } from 'rxjs';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ITopbarHeader } from '@core/interface/topbar.interface';
import { IconWrapperComponent } from '@shared/design/molecules/icon-wrapper/icon-wrapper.component';
import { ROUTES } from '@core/enum/common.enum';
import { CompanySelectorService } from '@core/services/presenters/company-selector.service';
import { CompanySelectorComponent } from '@shared/design/organisms/company-selector/company-selector.component';
import { ThemeService } from '@core/services/presenters/theme.service';

@Component({
  selector: 'app-layout-topbar',
  imports: [
    CommonModule,
    BreadcrumbModule,
    MenuModule,
    IconWrapperComponent,
    RouterModule,
    CompanySelectorComponent,
  ],
  templateUrl: './layout-topbar.component.html',
  styleUrl: './layout-topbar.component.scss',
})
export class LayoutTopbarComponent implements OnInit {
  userPerson = signal<UserPersonModel | null>(null);
  organizationCompany: Signal<OrganizationCompanyModel | null>;
  isAdmin = signal(false);
  isDark: Signal<boolean>;
  backRoute$: Observable<string>;
  topbarHeader$: Observable<ITopbarHeader>;
  readonly ROUTES = ROUTES;
  menuItems: MenuItem[] = [
    {
      label: 'Cerrar sesión',
      icon: 'pi pi-sign-out text-destructive-500 align-items-center mt-[4px]',
      command: () => {
        this.logout();
      },
    },
  ];

  constructor(
    private authService: AuthService,
    private topbarService: TopbarService,
    private localStorageService: LocalStorageService,
    private companySelectorService: CompanySelectorService,
    private themeService: ThemeService,
  ) {
    this.backRoute$ = this.topbarService.backRoute$;
    this.topbarHeader$ = this.topbarService.topbarHeader$;
    this.organizationCompany = this.companySelectorService.selectedCompany;
    this.isDark = this.themeService.isDark;
  }

  ngOnInit(): void {
    const userPerson = JSON.parse(
      this.localStorageService.getItem(STORAGE_USER_PERSON),
    );
    this.userPerson.set(userPerson);
    this.isAdmin.set(this.companySelectorService.isAdmin() || (userPerson?.organizationCompanys?.length ?? 0) > 1);
  }

  getShortName(): string {
    return `${this.userPerson()?.firstname?.charAt(
      0,
    )}${this.userPerson()?.lastname?.charAt(0)}`;
  }

  logout() {
    this.authService.logout();
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }
}
